/**
 * @file TanStack Query keys for our supported data types.
 */

/**
 * Query keys.
 */
const QueryKeys = {
  SCENARIOS: 'scenarios',
  SIMULATION_TYPES: 'simulation-types',
  SCENARIO_UNIT_MAP: 'scenario-unit-map',
  SCENARIO_PATIENT_CATEGORY_MAP: 'patient-category-map',
  UNITS: 'units',
  PATIENT_CATEGORIES: 'patient-categories',
  SIMULATION_RUNS: 'simulation-runs',
  SIMULATION_LOGS: 'simulation-logs',
};

export default QueryKeys;
